import config from 'config';
import { http_client } from './api';

const getList = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  student_type_id = null,
  subscription_type_id = null,
  class_type_id = null,
  school_type_id = null,
  tahun_ajaran_id = null,
  jenjang_id = null,
  cabang_id = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'harga?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${student_type_id ? '&student_type_id=' + student_type_id : ''}` +
        `${subscription_type_id ? '&subscription_type_id=' + subscription_type_id : ''}` +
        `${class_type_id ? '&class_type_id=' + class_type_id : ''}` +
        `${school_type_id ? '&school_type_id=' + school_type_id : ''}` +
        `${tahun_ajaran_id ? '&tahun_ajaran_id=' + tahun_ajaran_id : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${cabang_id ? '&cabang_id=' + cabang_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  student_type = null,
  subscription_type = null,
  class_type = null,
  school_type = null,
  tahun_ajaran_id = null,
  jenjang_id = null,
  cabang_id = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'harga/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${student_type ? '&student_type=' + student_type : ''}` +
        `${subscription_type ? '&subscription_type=' + subscription_type : ''}` +
        `${class_type ? '&class_type=' + class_type : ''}` +
        `${school_type ? '&school_type=' + school_type : ''}` +
        `${tahun_ajaran_id ? '&tahun_ajaran_id=' + tahun_ajaran_id : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${cabang_id ? '&cabang_id=' + cabang_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'harga', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'harga/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'harga/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'harga/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'harga/status/' + id, data).then((response) => {
    return response.data;
  });
};

const HargaService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default HargaService;
